<template>
  <div class="wm_selection_bread_crumb">
    <slot />
    <Btn
      :title="$ui.project_tree_keep_open ? 'Project tree ⇄' : 'Project tree ⇆'"
      @clicked="open_close_project_tree()"
      class="sidepanelbtn"
      :class="{ active: this.$ui.project_tree_keep_open }"
      style="margin: 0 6px 0 0;"
    />
    <router-link
      class="sel_breadcrumb_item"
      :title="$txt.hint_this_is_the_sltd_prj"
      v-if="$app.sltd.project"
      :to="{ name: 'project', params: { project_id: $app.sltd.project.id } }"
      >
      <SmartProjectIcon :project="$app.sltd.project" />
      {{ with_id($app.sltd.project.name, $app.sltd.project.id) }}
    </router-link>
  
    <span style="margin-top:45px">
      <span v-if="$app.sltd.cntrl" class="sel_breadcrumb_arrow">
        <svg-icon size="15" viewbox="0 0 24 24" :path="chevronRightIcon" />
      </span>
    </span>
    <router-link
      class="sel_breadcrumb_item"
      :title="$txt.hint_this_is_the_sltd_cntrl"
      v-if="$app.sltd.cntrl"
      :to="{
        name: 'controller',
        params: {
          project_id: $app.sltd.project.id,
          controller_id: $app.sltd.cntrl_id
        }
      }"
    >
      <span v-if="$app.sltd.cntrl">
        <SmartCntrlIcon :cntrl="$app.sltd.cntrl" />
        {{ with_id($app.sltd.cntrl.name, $app.sltd.cntrl.id) }}
      </span>
    </router-link>
    
    <span v-if="$app.sltd.zone" class="sel_breadcrumb_arrow">
      <svg-icon size="15" viewbox="0 0 24 24" :path="chevronRightIcon" />
    </span>
    <router-link
    class="sel_breadcrumb_item"
    :title="$txt.hint_this_is_the_sltd_zone"
    v-if="$app.sltd.zone"
    :to="{
      name: 'zone',
      params: { project_id: $app.sltd.project.id, zone_id: $app.sltd.zone.id }
    }"
    >
    <span v-if="$app.sltd.zone">
      <SmartZoneIcon :zone="$app.sltd.zone" />
      {{ with_id($app.sltd.zone.name, $app.sltd.zone.id) }}
    </span>  
  </router-link>
  
  <span v-if="$app.sltd.node" class="sel_breadcrumb_arrow">
    <svg-icon size="15" viewbox="0 0 24 24" :path="chevronRightIcon" />
  </span>
  <router-link
  class="sel_breadcrumb_item"
  :title="$txt.hint_this_is_the_sltd_node"
  v-if="$app.sltd.node"
  :to="{
    name: 'node',
    params: {
      project_id: $app.sltd.project.id,
      zone_id: $app.sltd.zone.id,
      node_id: $app.sltd.node.id
    }
  }"
    >
    <span v-if="$app.sltd.node">
      <SmartNodeIcon :node="$app.sltd.node" />
      {{ with_id($app.sltd.node.name, $app.sltd.node.id) }}
    </span>
  </router-link>
  
  <span style="float: right"
  >{{ $txt.project_time }}: {{ project_time }}</span
  >
  </div>
</template>

<script>
const chevronRightIcon  ="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z";
export default {
  setup() {
    return {
      chevronRightIcon
    }
  },
  name: "SelectionBreadCrumb",
  data() {
    return {
      project_time: ""
    };
  },

  props: {
    title: String
  },

  methods: {
    with_id(name, id) {
      if (!this.$app.settings.display_internal_id)
        return name;
      return name + " (" + this.$txt.internal_id + ":" + id + ")";
    },
    open_close_project_tree() {
      this.$ui.project_tree_keep_open = !this.$ui.project_tree_keep_open;
    },
    update_project_time() {
      if (this.$app.sltd.prj_id == null || this.$app.sltd.project == null) {
        this.project_time = this.$txt.loading;
        return;
      }
      this.project_time = this.$app.sltd.project.get_project_time_str();
    }
  },
  computed: {},

  created: function() {
    this.project_time = this.$txt.loading;
    this.project_time_timer = window.setInterval(this.update_project_time, 1000);
  },

  beforeUnmount() {
    window.clearInterval(this.project_time_timer);
  }
};
</script>
